// removed by extract-text-webpack-plugin
module.exports = {"container":"container-TGjxY","modal":"modal-3Iy3H","input":"input-3DGvi","labels":"labels-2bCRn","number":"number-N8JM8","right":"right-3ddk3","label":"label-1azqO","button":"button-1WgpU btn-3FsRe","button-input":"button-input-2gso_","upload":"upload-3rPTm","doc":"doc-hJD7n","btn":"btn-XQDuf btn-3FsRe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/order-terminal/style.scss
 ** module id = 156
 ** module chunks = 0
 **/